const fontFamilies = {
  default: `'Euclid Circular A', Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif`,
  serif: `'MongoDB Value Serif', 'Times New Roman', serif`,
  code: `'Source Code Pro', Menlo, monospace`,
  legacy: `Akzidenz, 'Helvetica Neue', Helvetica, Arial, sans-serif`,
} as const;

export default fontFamilies;
